import translateExchangeIds from '../services/translateExchangeIds';

/**
 * Translates the given restImmutableIds to the corresponding EWS ItemIds.
 * @param immutableIds immutableId to translate
 * @return array of TranslateExchangeIdsResponseItem
 */
export default function translateRestImmutableIdsToEwsIds(immutableIds: string[], headers?: any) {
    return translateExchangeIds('restImmutableEntryId', 'ewsId', immutableIds, headers);
}
